import React, { useMemo } from 'react'

import { ReactComponent as RemoveSvg } from '../../../assets/remove.svg'
import productUnavailable from '../../../assets/product_unavailable.png'
import SendGTAGEvent from '../../../utils/sendGTAGEvent';

import {
    Container,
    ItemImage,
    ItemInformationsContainer,
    ItemInformations,
    ItemInformationsButtonContainer
} from './styles'

interface IUserWishlistProductItemProps {
    items: {
        images: {
            imageUrl: string;
        }[]

        sellers: {
            sellerName: string;
            commertialOffer: {
                Price: number
            };
        }[]
    }[];
    linkText: string;
    productName: string;
    productReference: string;
    onClickRemoveButtonHandler: (linkText: string) => void;
}

const UserWishlistProductItem: React.FC<IUserWishlistProductItemProps> = ({
    items,
    linkText,
    productName,
    productReference,
    onClickRemoveButtonHandler
}) => {

    const realItemMemo = useMemo(() => items.find((item) => item.sellers.find(seller => seller.commertialOffer.Price > 0)), [items])

    const treatedUrlImageMemo = useMemo(() => {
        if (items[0].images[0].imageUrl) {
            return items[0].images[0].imageUrl
                .split('/')
                .map((item, index) => {
                    if (index === 5) {
                        return `${item}-500-750`
                    }
                    return item
                })
                .join('/')
        } else {
            return productUnavailable
        }
    }, [items])

    return (
        <Container>
            <ItemImage imageUrl={treatedUrlImageMemo}></ItemImage>
            <ItemInformationsContainer>
                <ItemInformations>
                    <h4>{productName}</h4>
                    <small>Ref.: {productReference}</small>
                    <strong>{realItemMemo ? `${realItemMemo.sellers[0].commertialOffer.Price.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}` : 'Indisponível'}</strong>
                </ItemInformations>
                <ItemInformationsButtonContainer>
                    <button onClick={() => {
                        onClickRemoveButtonHandler(linkText)
                        SendGTAGEvent(
                            'remover_item_lojinha',
                            'Lojinha',
                            'Clicou em botão "Remover item',
                            linkText
                        )
                    }}>
                        <RemoveSvg />
                        <span>Remover item</span>
                    </button>
                </ItemInformationsButtonContainer>
            </ItemInformationsContainer>
        </Container>
    )
}

export default UserWishlistProductItem